import { ConfigData } from "@configs/config-data.type";

export const localCfg: ConfigData = {
	apiUrl: 'http://localhost:3002',
	title: 'Local-Saltshaker',
	logos: {
		login: 'assets/images/logos/logo-text-white-v2.png',
		menu: 'assets/images/logos/logo-text-white.png',
	},
};
